module.exports = __webpack_public_path__ + "images/花筑奢pr长图_08-3.jpg?v=cbfa32b0";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu2/花筑奢pr长图_08-3.jpg
 ** module id = 46
 ** module chunks = 1 2
 **/